export enum PublishRulesKnmUnscheduledFormBlockNamesEnum {
  REQUIRED = 'required',
  NON_REQUIRED = 'nonRequired',
  PROMPTLY = 'promptly',
}
